module.exports = __webpack_public_path__ + "media/images/donate-any-5a6545bfb586b429f0371b5846e58e08.jpg";